import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import Header from "./components/layouts/header";
import Sidebar from "./components/layouts/sidebar";
import AppRouter from "./components/appRouter";
import { saveConfig } from "./store/slice/configSlice";
import { removeUser, saveUserData } from "./store/slice/userSlice";
import { apiBaseUrl, applicationId, redirectUrl } from "./env";
import FullScreenLoader from "./components/FullScreenLoader/fullScreenLoader";
import { myApplicationList } from "./store/slice/applicationSlice";

const App = () => {

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  const userData = useSelector((state) => state.userSlice);

  const configData = useSelector((state) => state.configSlice);


  const [sideBar, setSideBar] = useState(false);


  const getUserConfigData = async () => {
    setLoading(true);
    await axios
      .get(`${apiBaseUrl}/api/application/configuration/${applicationId}`)
      .then((response) => {
        const data = response.data.data.data;
        // data.apiBaseUrl="http://localhost:3000"
        dispatch(saveConfig({ data }));
        localStorage.setItem("apiBaseUrl",data.apiBaseUrl)
       
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    getUserConfigData();
  }, []);

  const fetchApplication = async (token) => {
    try {
      var { data } = await axios.get(`${configData.config.ssoUrl}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };


  const getUserDetail = async () => {

    const urlParams = new URLSearchParams(window.location.search);

    const _tokenParam = urlParams.get("referrer");

    let token = "";
    if (_tokenParam) {
      const decoded = jwtDecode(_tokenParam);
      localStorage.setItem("token", decoded.token);
      token = decoded.token;
    } else if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    } else {
      const currentURL = window.location.href;
      const baseUrl = new URL(currentURL).origin;
      const payload = {
        origin: baseUrl,
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${redirectUrl}?referrer=${token}`);
    }

    await axios
      .get(`${configData?.config?.ssoUrl}/api/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response?.status === 200) {
          localStorage.setItem("token", response?.data?.data?.token);
          const data = {
            token: response?.data?.data?.token,
            user: response?.data?.data?.user,
          };
          localStorage.setItem("user_uuid", response?.data?.data?.user.uuid);
          dispatch(saveUserData(data));
          setLoading(configData?.loading);
          fetchApplication(response?.data?.data?.token);
          localStorage.setItem("user_name", response?.data?.data?.user.name)
        
        }
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(removeUser());
        localStorage.clear();
        sessionStorage.clear();
        const currentURL = window.location.href;
        const baseUrl = new URL(currentURL).origin;
        const payload = {
          origin: baseUrl,
        };
        const token = jwtEncode(payload, "");
        window.location.href = `${redirectUrl}?referrer=${token}`;
      });
  };

  useEffect(() => {
    if (configData && configData.loading === false) {
      getUserDetail();
    }
  }, [configData]);



  return (
    <>
      {loading ? (
        <FullScreenLoader loading={loading} />
      ) : (
        <>
          <BrowserRouter>
            <Header sideBar={sideBar} setSideBar={setSideBar} />
            <Sidebar sideBar={sideBar} />
            <div className={sideBar ? "main-content sideactive" : "main-content"}>
              <AppRouter />
            </div>
          </BrowserRouter>
        </>
      )}
    </>
  );
};

export default App;
